import "./cafm.assets.jsx";
import "./cafm.assets.form.jsx";
import "./cafm.config.jsx";
import "./cafm.costs.jsx";
import "./cafm.documents.jsx";
import "./cafm.helpdesk.jsx";
import "./cafm.helpdesk.assignments.jsx";
import "./cafm.helpdesk.labourcharges.jsx";
import "./cafm.helpdesk.travel.jsx";
import "./cafm.helpdesk.actions.jsx";
import "./cafm.helpdesk.checklist.jsx";
import "./cafm.hierarchy.jsx";
import "./cafm.notes.jsx";
import "./cafm.prop.jsx";
import "./cafm.recurrence.jsx";
import "./cafm.reports.jsx";
import "./cafm.signature.jsx";
import "./cafm.stock.jsx";
import "./cafm.roombooking.jsx";
import "./cafm.roombooking.attendee.jsx";
import "./cafm.roombooking.equipment.jsx";
import "./cafm.roombooking.form.jsx";
import "./cafm.roombooking.scheduler.jsx";
import "./cafm.roombooking.service.jsx";
import "./cafm.setup.jsx";
import "./cafm.today.jsx";
import "./cafm.offline.jsx";